import AstraVGSFormModal from '#client/components/AstraVGSFormModal';

import useModalContext from './useModalContext';

const useOpenAstraModal = () => {
  const { openModal } = useModalContext();

  const getAndRedirectAstraUrl = async ({ isClearAllModal = false } = {}) => {
    openModal({
      component: AstraVGSFormModal,
      isClearAllModal
    });
  };

  return {
    getAndRedirectAstraUrl
  };
};

export default useOpenAstraModal;
